import { Palette, VR_LINEHEIGHT } from 'mm-theme-configuration';
import { VRFactory } from './verticalRhythm/verticalRhythm.utils';
import { MEDIA_BREAKPOINTS } from '../mediaQueries.const';

interface VerticalRhythm {
  vrLineHeight: { [key: string]: object }
  tagStyles: { [key: string]: object }
}

export class PaletteManager {
  palette: Palette;

  verticalRhythm: VerticalRhythm;


  constructor(palette: Palette) {
    this.palette = palette;
    const { vrLineHeight, tagStyles } = VRFactory(palette.verticalRhythmStrategies);
    this.verticalRhythm = { vrLineHeight: { [VR_LINEHEIGHT.ALL]: vrLineHeight }, tagStyles };
  }

  getColorByKey(key: string) {
    return this.palette.colors[key];
  }

  getFonts() {
    return this.palette.fonts;
  }

  getFontSizeMap() {
    return { ...this.palette.fontSizeMap };
  }

  getTypographyStyleByKey(key: string) {
    return {
      ...this.getTagStyle(key),
      ...this.palette.typography[key].style,
    };
  }

  getTagStyle(key: string) {
    return this.verticalRhythm.tagStyles[key];
  }

  getVrLineHeight(key: string) {
    return this.verticalRhythm.vrLineHeight[key];
  }

  getFontFamilyByKey(key: string) {
    return `${this.palette.typography[key].fontFamily}`;
  }

  getDefaultFontFamilyByKey(key: string) {
    return this.palette.typography[key].defaultFontFamily;
  }
}
